import { render, staticRenderFns } from "./teachingAndResearch.vue?vue&type=template&id=5a9af396&scoped=true"
import script from "./teachingAndResearch.vue?vue&type=script&lang=js"
export * from "./teachingAndResearch.vue?vue&type=script&lang=js"
import style0 from "./teachingAndResearch.vue?vue&type=style&index=0&id=5a9af396&prod&scoped=scoped&lang=scss"
import style1 from "./teachingAndResearch.vue?vue&type=style&index=1&id=5a9af396&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9af396",
  null
  
)

export default component.exports